import { Issuance } from '../../../../types/MaterialRequest';
import { Table, TableColumnType } from 'antd';

const MaterialRequestIssuanceTable = ({
  issuanceTable,
}: {
  issuanceTable?: Issuance[];
}) => {
  const columns: TableColumnType<Issuance>[] = [
    {
      title: 'Code',
      dataIndex: 'productCode',
      render: (_text, record) => <span>{record.product.code}</span>,
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      render: (_text, record) => <span>{record.product.description}</span>,
    },
    {
      title: 'Product UoM',
      dataIndex: 'productUoM',
      render: (_text, record) => <span>{record.productUom?.description}</span>,
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
    },
    {
      title: 'Type',
      dataIndex: 'moveType',
      // render: (_text, record) => <StatusTag status={record.moveType} />,
    },
    {
      title: 'Move Date',
      dataIndex: 'moveDate',
    },
  ];

  return (
    <>
      <Table
        rowKey={(record) => record.id}
        dataSource={issuanceTable}
        columns={columns}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
      />
    </>
  );
};

export default MaterialRequestIssuanceTable;
